import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp4};
  box-sizing: border-box;
  width: 100%;
  padding: ${props => props.theme.whiteLabel.spacing.sp12};
  border: 1px solid ${props => props.theme.colors.grey.tone100};
  border-radius: 8px;
  background-color: ${props => props.theme.colors.white};
  overflow: hidden;
`

export const NameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  overflow: hidden;
`

export const CarrierLogo = styled.img`
  height: 24px;
  width: 38px;
  object-fit: contain;
`

export const Name = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
